import { createStore } from 'vuex'
// 本地化存储
import createPersistedState from "vuex-persistedstate";
import loginModel from "./login"
import sysModel from "./sys"

export default createStore({
  state: {
    isLoading: false
  },
  getters: {
  },
  mutations: {
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    }
  },
  actions: {
    showLoading({ commit }) {
      commit('setLoading', true);
    },
    hideLoading({ commit }) {
      commit('setLoading', false);
    }
  },
  modules: {
    loginModel: loginModel,
    sysModel:sysModel,
  },
  // 设置本地化存储
  plugins: [
    // 默认储存在localstorage
    createPersistedState({
      // 本地储存名
      key: 'jiangxuejing1q2w3e4r',
      // 指定数据进行本地存储
      paths: ['loginModel.login','loginModel.role','loginModel.loginName',"loginModel.isSupperAdmin"]
    })
  ],
})
